import { confirmDialog } from 'primereact/confirmdialog';

/** Запрашивает подтверждение потери изменений перед закрытием редактора */
export const confirmUnsavedChanges = (
    when: boolean,
    onLeave: () => void,
): void => {
    if (!when) {
        onLeave();

        return;
    }

    confirmDialog({
        header: 'Несохранённые изменения',
        message: 'У вас есть несохранённые изменения. Хотите уйти? Изменения будут потеряны',
        icon: 'pi pi-exclamation-triangle',
        acceptLabel: 'Уйти',
        rejectLabel: 'Остаться',
        acceptClassName: 'p-button-danger',
        defaultFocus: 'reject',
        accept: onLeave,
    });
};
